
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Send } from 'lucide-react';

export const XLogo = ({ className = "w-5 h-5" }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

export const SocialMediaIcons: React.FC<{ className?: string }> = ({ className = "flex gap-4 items-center" }) => {
    return (
        <div className={className}>
            <a 
                href="https://x.com/HotNetwork_sol" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-stone-400 hover:text-white transition-colors group"
                title="Follow us on X"
            >
                <div className="p-2 rounded-full bg-stone-800/50 group-hover:bg-stone-800 transition-colors">
                    <XLogo className="w-4 h-4" />
                </div>
            </a>
            <a 
                href="https://t.me/HotNetwork" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-stone-400 hover:text-white transition-colors group"
                title="Join our Telegram"
            >
                <div className="p-2 rounded-full bg-stone-800/50 group-hover:bg-stone-800 transition-colors">
                    <Send className="w-4 h-4" />
                </div>
            </a>
        </div>
    );
};
